import React from "react";
import { FaRegWindowClose, FaEnvelope } from "react-icons/fa";

const ConfirmEmailBox = ({ Modalclose, handleSubmit }) => {
  return (
    <>
      <div className="modal-wrapper email-confirm-overlay" onClick={Modalclose}></div>
      <div className="modal-container email-confirm-box">
        <div className="close-icon">
          <FaRegWindowClose onClick={Modalclose} />
        </div>
        <div className="modal-body">
          <section className="email-confirm-section">
            <div className="email-confirm-content">
              <div className="icon-circle">
                <FaEnvelope className="envelope-icon" />
              </div>
              <h2>Confirm Email Reclassification</h2>
              <p>
               Your action helps us improve how similar emails are handled in the future.
              </p>  
              <div className="delete-buttons">
                <button className="cancel-button btn btn-secondary" onClick={Modalclose}>
                  No 
                </button>
                <button className="confirm-button btn btn-danger" onClick={handleSubmit}>
                  Yes
                </button>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default ConfirmEmailBox;
